import * as React from 'react';
import * as _ from 'lodash';
import PagerEx from '../../components/PageLayout/PagerEx';
export default function () {
    function onClick1(item, itemIndex) {
        this.props.selectPreset(item.id);
    }
    function onClick2(item, itemIndex) {
        this.editPreset(item.id);
    }
    function onClick3(item, itemIndex) {
        this.props.deletePreset(item.id);
    }
    function onClick4(item, itemIndex) {
        this.showAddAssignees(item.id);
    }
    function onBlur5(item, itemIndex, e) {
        this.updatePresetValue('name', e);
    }
    function onBlur6(item, itemIndex, e) {
        this.updatePresetValue('description', e);
    }
    function repeatFeature7(item, itemIndex, feature, featureIndex) {
        return React.createElement('li', {
            'className': 'feature-inclusion-items-list__item',
            'key': 'feature_' + feature.id
        }, feature.name);
    }
    function repeatAssignee8(item, itemIndex, assignee, assigneeIndex) {
        return React.createElement('li', {
            'className': 'feature-inclusion-items-list__item',
            'key': 'assignee_' + assignee.id
        }, assignee.name);
    }
    function repeatItem9(item, itemIndex) {
        return React.createElement('li', {
            'className': 'feature-inclusion-list__item',
            'key': item.id
        }, React.createElement('div', { 'className': 'feature-inclusion-list__item-row' }, React.createElement('div', { 'className': 'feature-inclusion-item feature-inclusion-item--left-buttons' }, React.createElement('div', { 'className': 'feature-inclusion-open-icon' }, React.createElement('button', {
            'className': 'ui-icon-arrow ' + (item.id == this.props.selectedPreset ? 'ui-icon-arrow--down' : 'ui-icon-arrow--right'),
            'onClick': onClick1.bind(this, item, itemIndex)
        })), React.createElement('button', {
            'className': 'ui-icon-edit',
            'onClick': onClick2.bind(this, item, itemIndex)
        })), React.createElement('div', { 'className': 'feature-inclusion-item feature-inclusion-item--remove' }, React.createElement('button', {
            'className': 'ui-icon-remove',
            'onClick': onClick3.bind(this, item, itemIndex)
        })), React.createElement('div', { 'className': 'feature-inclusion-item feature-inclusion-item--name' }, item.name), React.createElement('div', { 'className': 'feature-inclusion-item feature-inclusion-item--button' }, React.createElement('button', {
            'className': 'ui-button4 ui-button4--blue ui-button4--large',
            'onClick': onClick4.bind(this, item, itemIndex)
        }, 'Add Assignees'))), this.props.selectedPreset == item.id ? React.createElement('div', {
            'className': 'feature-inclusion-list__item-dropdown',
            'key': 'preset_' + item.id
        }, React.createElement('div', { 'className': 'feature-inclusion-dropdown' }, React.createElement('div', { 'className': 'feature-inclusion-dropdown__title' }, 'Feature Inclusion Parameters'), React.createElement('div', { 'className': 'feature-inclusion-dropdown__content' }, React.createElement('div', { 'className': 'feature-inclusion-settings' }, React.createElement('div', { 'className': 'feature-inclusion-settings__block' }, React.createElement('span', { 'className': 'feature-inclusion-title' }, 'preset name'), React.createElement('input', {
            'className': 'ui-input2 feature-inclusion-settings__block-filter-name',
            'type': 'text',
            'placeholder': 'Enter Filter name',
            'defaultValue': item.name,
            'onBlur': onBlur5.bind(this, item, itemIndex)
        })), React.createElement('div', { 'className': 'feature-inclusion-description__block' }, React.createElement('span', { 'className': 'feature-inclusion-title' }, 'description'), React.createElement('textarea', {
            'className': 'ui-input2 feature-inclusion-dropdown-list__block-textarea',
            'placeholder': 'Enter Group description',
            'defaultValue': item.description,
            'onBlur': onBlur6.bind(this, item, itemIndex)
        }))), React.createElement('div', { 'className': 'feature-inclusion-dropdown-list' }, React.createElement('div', { 'className': 'feature-inclusion-dropdown-list__block' }, React.createElement('div', { 'className': 'feature-inclusion-description__block' }, React.createElement('span', { 'className': 'feature-inclusion-title feature-inclusion-title--lined' }, 'Feature items included'), React.createElement.apply(this, [
            'ul',
            { 'className': 'ul-list feature-inclusion-items-list' },
            _.map(this.getUniqueFeatures(item.features), repeatFeature7.bind(this, item, itemIndex))
        ])))), React.createElement('div', { 'className': 'feature-inclusion-dropdown-list' }, React.createElement('div', { 'className': 'feature-inclusion-dropdown-list__block' }, React.createElement('div', { 'className': 'feature-inclusion-description__block' }, React.createElement('span', { 'className': 'feature-inclusion-title feature-inclusion-title--lined' }, 'Asignees'), React.createElement.apply(this, [
            'ul',
            { 'className': 'ul-list feature-inclusion-items-list' },
            _.map(item.assignees, repeatAssignee8.bind(this, item, itemIndex))
        ]))))))) : null);
    }
    return React.createElement('div', { 'className': 'feature-inclusion-container' }, React.createElement.apply(this, [
        'ul',
        { 'className': 'feature-inclusion-list ui-list' },
        _.map(this.props.pagedFeatureInclusionData, repeatItem9.bind(this))
    ]), this.props.totalPages > 1 ? React.createElement(PagerEx, {
        'pageCount': this.props.totalPages,
        'forcePage': this.state.page,
        'onPageChange': page => this.setPage(page),
        'key': '3884'
    }) : null);
}